import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useClipTextOnScreenPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canSee, canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      canSee: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.VIEW_CLIP_TEXT_ON_SCREEN]),
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_TEXT_ON_SCREEN]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_TEXT_ON_SCREEN]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CLIP_TEXT_ON_SCREEN]),
    }),
    [hasPlatformPermission]
  );

  return {
    canSee,
    canCreate,
    canUpdate,
    canDelete,
  };
};
